<script setup lang="ts">
import BaseButton from '~/components/common/base-button.vue'
import { useDevice } from '#imports'
const { isMobile } = useDevice()
useSeoMeta({
  robots: {
    nofollow: true,
    noindex: true,
  },
})
</script>
<template>
  <section :class="['not-found', { mobile: isMobile }]">
    <div class="container d-flex justify-content-center align-items-center flex-column">
      <div :class="{ 'mb-5': !isMobile }">
        <div class="not-found__image">
          <img src="/assets/images/pages/404/404.png" alt="404" />
        </div>
        <div class="not-found__desc text-center">
          <h3>Không tìm thấy trang</h3>
          <p>Trang bị xóa hoặc địa chỉ URL không đúng</p>
          <template v-if="!isMobile">
            <BaseButton size="medium" class="button main main--primary" style="height: 40px; width: 200px" to="/">
              Trang chủ
            </BaseButton>
          </template>
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="button-fixed-bottom">
      <BaseButton size="medium" class="button main main--primary" to="/">Trang chủ</BaseButton>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~scssAsset/components/common/404.scss';
</style>
